// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconArrowRightToLine } from '@ni/nimble-components/dist/esm/icons/arrow-right-to-line';
import { wrap } from '../utilities/react-wrapper';

export { type IconArrowRightToLine };
export const NimbleIconArrowRightToLine = wrap(IconArrowRightToLine);